import { Link } from "react-router-dom";
import { PageHeader } from "../components/layout";
import { EmptyState, NotConfiguredState } from "../components/states";
import { usePlatformStatus } from "../hooks/usePlatformStatus";
import { Card, StatusIndicator } from "../components/ui";

export function Servers(): JSX.Element {
  return (
    <>
      <PageHeader title="Servers">
        <p>Discord servers you manage with ODIN will appear here once you connect one.</p>
      </PageHeader>
      <EmptyState title="No servers connected yet">
        <p>
          Connecting a Discord server requires sign-in and bot provisioning, which arrive in a later
          phase.
        </p>
      </EmptyState>
    </>
  );
}

export function Settings(): JSX.Element {
  const status = usePlatformStatus();
  return (
    <>
      <PageHeader title="Settings">
        <p>Your account and the platform safety configuration this workspace runs under.</p>
      </PageHeader>
      <div className="card-grid">
        <Card title="Account">
          <p>
            Discord, Google and email all sign you in to the same ODIN account. Manage which providers
            are attached, which of them can recover your access — and delete your account, if that is
            what you want.
          </p>
          <p>
            <Link to="/app/settings/linked-accounts" className="ax-card__link">
              Linked accounts
            </Link>
          </p>
        </Card>
        <Card title="Workspace">
          <p>
            Your workspace holds the Discord servers you have connected, their snapshots and their
            BALDER history. See who is in it, what your plan allows it — and delete it, if that is
            what you want.
          </p>
          <p>
            <Link to="/app/settings/workspace" className="ax-card__link">
              Workspace settings
            </Link>
          </p>
        </Card>
      </div>
      {status.kind === "ready" ? (
        <div className="card-grid">
          <div className="card">
            <h3 className="card__title">Safety</h3>
            <div style={{ display: "grid", gap: "0.5rem" }}>
              <StatusIndicator
                tone={status.data.safety.dryRun ? "ok" : "warn"}
                label={`Dry run: ${status.data.safety.dryRun ? "on" : "off"}`}
              />
              <StatusIndicator
                tone={status.data.safety.allowLiveDeploy ? "warn" : "ok"}
                label={`Allow live deploy: ${status.data.safety.allowLiveDeploy ? "on" : "off"}`}
              />
              <StatusIndicator
                tone={status.data.safety.requireApproval ? "ok" : "danger"}
                label={`Require approval: ${status.data.safety.requireApproval ? "on" : "off"}`}
              />
            </div>
          </div>
        </div>
      ) : (
        <NotConfiguredState title="Settings will populate once the API is reachable" />
      )}
    </>
  );
}
